import favicon16 from "./favicons/favicon-notification16x16.png?inline";
import favicon32 from "./favicons/favicon-notification32x32.png?inline";

let msgCount = 0;
let hasUserNavigated = false;
let originalTitle;
let favIcon32;
let favIcon16;
let isListenerAttached = false;

const originalHrefs = {
  "32x32": "/favicon-32x32.png",
  "16x16": "/favicon-16x16.png",
};

const handleVisibilityChange = () => {
  if (document.hidden) {
    hasUserNavigated = true;
  } else {
    hasUserNavigated = false;
    if (msgCount > 0) {
      document.title = originalTitle;
      msgCount = 0;
    }
    favIcon32.href = originalHrefs["32x32"];
    favIcon16.href = originalHrefs["16x16"];
  }
};

export const onAgentMessageEnd = async () => {
  if (typeof document !== "undefined") {
    favIcon32 = document.head.querySelector('link[rel="icon"][sizes="32x32"]');
    favIcon16 = document.head.querySelector('link[rel="icon"][sizes="16x16"]');
    document.addEventListener("visibilitychange", handleVisibilityChange);
    isListenerAttached = true;

    if (hasUserNavigated) {
      if (msgCount === 0) {
        originalTitle = document.title;
      }
      msgCount++;
      document.title = `(${msgCount}) ${originalTitle}`;
      favIcon16.href = favicon16;
      favIcon32.href = favicon32;
    }
  }
};

export const cleanupNotificationHandler = () => {
  if (isListenerAttached) {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    isListenerAttached = false;
  }
};
